export default "__VITE_ASSET__CCOVj5gh__"